import {RootState} from 'store'

export const getEntries = (state: RootState) => state.topcup.entries
